<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { tchMarked } from "@common/Common";
    import { CriterionDetailsDialogViewModel } from "@Criteria/Hierarchies/Components/CriterionDetailsDialog";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriterionDetailsDialog extends Vue
    {
        get vm(): CriterionDetailsDialogViewModel { return this.$props.viewModel as CriterionDetailsDialogViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get name(): string { return this.vm.name; }
        get path(): string { return this.vm.path; }
        get description(): string { return this.vm.description; }
        get descriptionHtml(): string{ return tchMarked(this.description); }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span>{{name}}</span><br />
                            <small class="text-muted">{{path}}</small>
                        </h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p v-if="!description" class="text-muted font-italic lead">No description provided</p>
                        <div v-html="descriptionHtml"></div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>